import type { FunctionComponent, PropsWithChildren } from 'react';
import { Navigate } from 'react-router';
import type { IResponse } from '../gql/get-user';

export const UserRequired: FunctionComponent<
  PropsWithChildren<{ user: IResponse | undefined; redirectionPath?: string }>
> = ({ children, user, redirectionPath = '/' }) => {
  if (!user || !user.loggedInUser) {
    return <Navigate to={redirectionPath} />;
  }

  return <>{children}</>;
};
